import { render } from "./OrdenesFacturacion.vue?vue&type=template&id=6c0723e4"
import script from "./OrdenesFacturacion.vue?vue&type=script&lang=js"
export * from "./OrdenesFacturacion.vue?vue&type=script&lang=js"

import "./OrdenesFacturacion.vue?vue&type=style&index=0&id=6c0723e4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__